// extracted by mini-css-extract-plugin
export default {"video-player":"_3HQ34","videoPlayer":"_3HQ34"};